import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
@Component({
  selector: 'app-tank-stage3',
  templateUrl: './tank-stage3.component.html',
  styleUrls: ['./tank-stage3.component.scss']
})
export class TankStage3Component implements OnInit {

  constructor(
    private route: ActivatedRoute, 
    private cryptoJsService: CryptoJsService, 
    private router: Router,
    private activityRecordService: ActivityRecordService
    ) { }


  items: any[];
  autoId: any;
  appId: any;

  activeItem: any;
  userID: any;

  ngOnInit() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userID = JSON.parse(payload)?.sub;


    let parentRoute = this.router.url.split('/')[1];
    this.route.queryParams
      .subscribe(params => {
        // this.autoId = params.autoId;
        // this.appId = params.appId;
        this.items = [
          { label: 'Pending', routerLink: `/${parentRoute}/tank-stage3/pending`},
          { label: 'Current', routerLink: `/${parentRoute}/tank-stage3/current`},
          { label: 'Further Action Taken', routerLink: `/${parentRoute}/tank-stage3/approved` },          
        ];
      }
      );
  }
}


